import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNumbersOnly]'
})
export class NumbersOnlyDirectiveDirective {

  constructor(private ngControl: NgControl) {}

  // 🔢 Key press filter
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];
    if (allowedKeys.includes(event.key)) return;

    // Allow only digits
    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }

  // 🔢 Paste filter
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const pastedInput = event.clipboardData?.getData('text') || '';
    if (!/^\d+$/.test(pastedInput)) {
      event.preventDefault();
    }
  }

  // 🔢 Input event: sanitize the value and update ngModel
  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    let value = inputElement.value;

    // Remove all non-numeric characters and limit length to 16
    const numericValue = value.replace(/\D/g, '').slice(0, 16);

    if (value !== numericValue) {
      // Update input element
      inputElement.value = numericValue;

      // Update ngModel if present
      if (this.ngControl.control) {
        this.ngControl.control.setValue(numericValue, { emitEvent: false });
      }
    }
  }
}
